<template>
    <div class="pt-container">
        <div class="login-title">
            <v-login-status ref="loginStatus"></v-login-status>
        </div>
        <div class="main-content">
            <el-row>
                <div class="pt-header">
                    <div class="pt-logo">
                        <img src="../../../assets/img/logo2.png" width="120" height="40"/>
                    </div>
                    <div style="float: left; background-color: white; width: 3px; height: 40px; margin-top: 20px; margin-left: 5px; margin-right: 5px;"></div>
                    <div class="pt-websitename">
                        <div class="pt-websitename-top">广东省智能家电产业专利专题数据库</div>
                        <!-- <div class="pt-websitename-bom">Guangdong Smart Home Industry Intellectual Property Public Service Platform</div> -->
                    </div>
                    <div class="pt-web-total">总访问量：{{ webtotal.webCount }}，今日访问量：{{ webtotal.userCount }}</div>
                </div>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <div class="pt-class"><el-divider direction="vertical"></el-divider>专利分类</div>
                    <div class="pt-menus-list">
                        <el-menu
                            class="sidebar-el-menu"
                            @select="menuSelect"
                            unique-opened
                        >
                        <template v-for="item in resourceData">
                            <template v-if="item.children.length > 0">
                                <el-submenu :index="item.id" :key="item.id" style="background-color: #07367d;">
                                    <template slot="title">
                                        <span slot="title" style="color: white; font-size: 20px;">{{ item.rsName }}</span>
                                    </template>
                                    <template v-for="subItem in item.children">
                                        <el-submenu
                                            v-if="subItem.children.length > 0"
                                            :index="subItem.id"
                                            :key="subItem.id"
                                        >
                                            <template slot="title">{{ subItem.rsName }}</template>
                                            <el-menu-item
                                            v-for="(threeItem, i) in subItem.children"
                                            :key="i"
                                            :index="threeItem.id"
                                            >{{ threeItem.rsName }}</el-menu-item
                                            >
                                        </el-submenu>
                                        <el-menu-item
                                            v-else
                                            :index="subItem.id"
                                            :key="subItem.id"
                                            >{{ subItem.rsName }}
                                        </el-menu-item>
                                    </template>
                                </el-submenu>
                            </template>
                            <template v-else>
                                <el-menu-item :index="item.id" :key="item.id">{{ item.rsName }}</el-menu-item>
                            </template>
                        </template>
                        </el-menu>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div class="pt-menus">
                        <div class="pt-menus-left"><el-divider direction="vertical"></el-divider>专利列表</div>
                        <div class="pt-menus-right">
                            <span :class="lg === 'zh' ? 'pt-lg-zh-focus' : 'pt-lg-zh'" @click="zhSearch">中</span>
                            <span :class="lg === 'en' ? 'pt-lg-en-focus' : 'pt-lg-en'" @click="enSearch">外</span>
                            <el-button class="pt-search-btn" plain type="info" size="medium" icon="el-icon-search" @click="showCustomSearchDialog">自定义检索</el-button>
                        </div>
                        <div style="float: right; height: 60px; width: 150px; line-height: 70px; font-size: 12px; color: #303133;">总记录：{{ zhTotal + enTotal }} 条</div>
                    </div>
                    <div class="pt-select">
                        <el-row :gutter="2">
                            <el-col :span="5">
                                <el-select v-model="queryParams.ptType" style="margin-left: 10px;" placeholder="专利类型" @change="handlePatentTypeChange">
                                    <el-option label="专利类型" :value="0"></el-option>
                                    <el-option label="发明专利" :value="1"></el-option>
                                    <el-option label="实用新型专利" :value="2"></el-option>
                                    <el-option label="外观设计专利" :value="3"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="5">
                                <el-select :disabled="lg === 'zh' ? false : true" v-model="queryParams.proposerType" placeholder="申请人类型" @change="handleApplyChange">
                                    <el-option label="申请人类型" :value="0"></el-option>
                                    <el-option label="机关团体" :value="3"></el-option>
                                    <el-option label="大专院校" :value="2"></el-option>
                                    <el-option label="科研单位" :value="5"></el-option>
                                    <el-option label="个人" :value="4"></el-option>
                                    <el-option label="工矿企业" :value="1"></el-option>
                                    <el-option label="其他" :value="6"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="3">
                                <el-select :disabled="lg === 'zh' ? false : true" v-model="queryParams.lawStatus" placeholder="法律状态" @change="handlelawStatusChange">
                                    <el-option label="法律状态" :value="0"></el-option>
                                    <el-option label="有权" :value="2"></el-option>
                                    <el-option label="失效" :value="4"></el-option>
                                    <el-option label="届满" :value="5"></el-option>
                                    <el-option label="在审" :value="1"></el-option>
                                    <el-option label="无权" :value="3"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4">
                                <el-select :disabled="lg === 'zh' ? true : false" v-model="queryParams.appCoun" placeholder="申请人国别" @change="handleCountryChange">
                                    <el-option label="申请人国别" value=""></el-option>
                                    <el-option v-for="item in countryNames" :key="item" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4">
                                <el-select v-model="patentOrder" placeholder="排序" @change="handleSortChange">
                                    <el-option label="排序" :value="0"></el-option>
                                    <el-option label="申请日升序" :value="1">
                                        <span style="float: left">申请日升序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-top"></i></span>
                                    </el-option>
                                    <el-option label="申请日降序" :value="2">
                                        <span style="float: left">申请日降序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-bottom"></i></span>
                                    </el-option>
                                    <el-option label="公开日升序" :value="3">
                                        <span style="float: left">公开日升序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-top"></i></span>
                                    </el-option>
                                    <el-option label="公开日降序" :value="4">
                                        <span style="float: left">公开日降序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-bottom"></i></span>
                                    </el-option>
                                    <el-option v-show="lg === 'zh'" label="授权日升序" :value="5">
                                        <span style="float: left">授权日升序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-top"></i></span>
                                    </el-option>
                                    <el-option v-show="lg === 'zh'" label="授权日降序" :value="6">
                                        <span style="float: left">授权日降序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-bottom"></i></span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="1">
                                <el-button :disabled="lg === 'zh' ? false : true" @click="showReport" plain type="warning" icon="el-icon-pie-chart">分析</el-button>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="pt-info-list">
                        <el-table :data="patentDataList" style="width: 100%" :border="false" :show-header="false" stripe @row-click="selectRow">
                            <el-table-column prop="date" label="日期">
                                <template slot-scope="scope">
                                    <v-list-item :data="scope.row"></v-list-item>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pt-info-page">
                        <el-pagination 
                            background 
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryParams.pageNo"
                            :page-sizes="[10, 50]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next" 
                            :total="patentDataTotal">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <div class="pt-footer">
                    <div class="pt-footer-1">
                        公司地址：广州市天河区金颖路1号金颖大厦16楼<br/>
                        联系电话：020-38743199；38744550；85294797；38550992；38550875；38550767     邮编：510640
                    </div>
                    <!-- <div class="pt-footer-2">
                        五山（华工）办事处地址：广州市天河区金颖路1号金颖大厦16楼<br/>
                        联系电话：020-38550992    38550875    38550767    邮编：510640
                    </div> -->
                </div>
            </el-row>
        </div>


        <!-- 专利详情页面 -->
        <el-dialog :title="'专利详情：' + showDetailTitle" :visible.sync="showPatentDetailDialog" v-if="showPatentDetailDialog" width="1000px">
            <div slot="title">
                <v-dialog-title :data="currentDetailPatent"></v-dialog-title>
            </div>
            <v-pt-detail :data="currentDetailPatent"></v-pt-detail>
        </el-dialog>


        <!-- 专利分析页面 -->
        <el-dialog title="专利检索分析" :visible.sync="showReportDialog" v-if="showReportDialog" width="1160px" top="5vh">
            <div slot="title" style="font-size: 20px; font-weight: bold; color: #409EFF;">检索分析</div>
            <!-- <v-main :data="searchDecision"></v-main> -->
            <v-main2 :data="searchDecision"></v-main2>
        </el-dialog>


        <!-- 自定义检索 -->
        <el-dialog title="自定义检索" :visible.sync="showDetailSearchDialog" width="800px">
            <v-search ref="customSearchDialogRef" @onSearch="doRealCustomSearch"></v-search>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showDetailSearchDialog = false">取 消</el-button>
                <el-button type="primary" @click="sendCustomSearchEvent">搜 索</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import vLoginStatus from '../../common/LoginStatus.vue';
import vListItem from './PtZnjjListItem.vue';
import vPtDetail from './PtZnjjDetail.vue';
import vSearch from './plus/Search.vue';
import vMain from './analysis/Main.vue';
import vMain2 from './analysis/Main2.vue';
import vDialogTitle from './detail/DialogTitle.vue';
export default {
    components: {
        vListItem,
        vPtDetail,
        vSearch,
        vMain,
        vDialogTitle,
        vMain2,
        vLoginStatus
    },
    data() {
        return {
            showPatentDetailDialog: false,
            showReportDialog: false,
            showDetailSearchDialog: false,
            lg: 'zh',   // 中英文切换, zh/en
            queryParams: {
                ptType: 0,
                proposerType: 0,
                sortFeild: 0,
                sortType: 0,
                lawStatus: 0,
                appCoun: '',
                pageNo: 1,
                pageSize: 10
            },
            patentOrder: 0,
            patentDataList: [],
            patentDataTotal: 0,
            currentSelectMenu: null,
            showDetailTitle: '',
            currentDetailPatent: {},
            // 检索决策数据
            searchDecision: {
                st: 0,  // 检索类型，1：类型检索，2：中文自定义检索，3：英文自定义检索
                lang: 'zh',   // 语言类型，‘zh’中文，‘en’英文
                params: null,   // 检索参数
                type: '',   // 家用电器专利分类
                analysis: 0,  // 0自定义菜单检索，1类型菜单检索
                analysisDbType: 10, // 数据库类型
            },
            countryNames: [],
            resourceData: [],
            menusMap: null,
            enTotal: 0,
            zhTotal: 0,
            webtotal: {
                webCount: 0,
                userCount: 0
            }
        }
    },
    created() {
        this.loadCountryNames();
        this.loadResourceTree();
        this.loadEnTotal();
        this.loadZhTotal();
        this.loadCountData();
    },
    methods: {
        checkLogin() {
            let user = localStorage.getItem('token');
            if (!user) {
                this.$refs.loginStatus.onLogin();
                return false;
            } else {
                return true;
            }
        },
        async loadCountData() {
            const { data: res } = await this.$http.get("user/load/webcount");
            if (res.code == 0) {
                this.webtotal = res.data;
            }
        },
        async loadEnTotal() {
            const { data: res } = await this.$http.get("patent/count/en/patent/10");
            if (res.code == 0) {
                this.enTotal = res.data;
            }
        },
        async loadZhTotal() {
            const { data: res } = await this.$http.get("patent/count/zh/patent/10");
            if (res.code == 0) {
                this.zhTotal = res.data;
            }
        },
        menuSelect(data) {
            // console.log(data);
            var menu = this.menusMap.get(data);
            if (menu != null) {
                if (menu.funType === 0) {
                    //检索式
                    this.searchInType({index: menu.typeCode});
                } else if (menu.funType === 1) {
                    //技术手段
                    this.searchByTechDesc({index: menu.typeCode});
                } else if (menu.funType === 2) {
                    //专利级别
                    if (menu.ptLevel === 0) {
                        //一般专利
                        this.searchInType({index: "22"});
                    } else if (menu.ptLevel === 1) {
                        //重要专利
                        this.searchInType({index: "11"});
                    } else {
                        //核心专利
                        this.searchInType({index: "00"});
                    }
                }
            }
            //console.log(menu);
        },
        buildMap(menusData) {
            for (let index = 0; index < menusData.length; index++) {
                const d = menusData[index];
                this.menusMap.set(d.id, d);
                if (d.children.length > 0) {
                    this.buildMap(d.children);
                }
            }
        },
        async loadResourceTree() {
            const { data: res } = await this.$http.get("sc/menus/find/simple/tree/10");
            if (res.code == 0) {
                this.resourceData = res.data;
                this.menusMap = new Map();
                this.buildMap(this.resourceData);
            } else {
                this.$message.error('加载菜单失败');
            }
        },
        async loadCountryNames() {
            const { data: res } = await this.$http.get("search/country/names");
            if (res.code == 0) {
                this.countryNames = res.data;
            }
        },
        handleSizeChange(newSize) {
            this.queryParams.pageSize = newSize;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            if (this.searchDecision.type === '190') {
                this.loadPatantTechDescDatas();
            } else {
                this.loadPatantDatas();
            }
        },
        handleCurrentChange(newPage) {
            this.queryParams.pageNo = newPage;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            if (this.searchDecision.type === '190') {
                this.loadPatantTechDescDatas();
            } else {
                this.loadPatantDatas();
            }
        },
        handlePatentTypeChange() {
            // 选择类型过滤
            this.searchDecision.params.ptType = this.queryParams.ptType;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            if (this.searchDecision.type === '190') {
                this.loadPatantTechDescDatas();
            } else {
                this.loadPatantDatas();
            }
        },
        handleApplyChange() {
            // 选择申请人类型
            this.searchDecision.params.proposerType = this.queryParams.proposerType;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            if (this.searchDecision.type === '190') {
                this.loadPatantTechDescDatas();
            } else {
                this.loadPatantDatas();
            }
        },
        handlelawStatusChange() {
            // 选择法律类型
            this.searchDecision.params.lawStatus = this.queryParams.lawStatus;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            if (this.searchDecision.type === '190') {
                this.loadPatantTechDescDatas();
            } else {
                this.loadPatantDatas();
            }
        },
        handleCountryChange() {
            // 选择国别
            this.searchDecision.params.appCoun = this.queryParams.appCoun;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            if (this.searchDecision.type === '190') {
                this.loadPatantTechDescDatas();
            } else {
                this.loadPatantDatas();
            }
        },
        handleSortChange() {
            // 选择排序
            if (this.searchDecision.type === '190') {
                this.loadPatantTechDescDatas();
            } else {
                this.loadPatantDatas();
            }
        },
        findOrder() {
            switch (this.patentOrder) {
                case 1:
                    this.queryParams.sortFeild = 1;
                    this.queryParams.sortType = 1;
                    break;
                case 2:
                    this.queryParams.sortFeild = 1;
                    this.queryParams.sortType = 2;
                    break;
                case 3:
                    this.queryParams.sortFeild = 2;
                    this.queryParams.sortType = 1;
                    break;
                case 4:
                    this.queryParams.sortFeild = 2;
                    this.queryParams.sortType = 2;
                    break;
                case 5:
                    this.queryParams.sortFeild = 3;
                    this.queryParams.sortType = 1;
                    break;
                case 6:
                    this.queryParams.sortFeild = 3;
                    this.queryParams.sortType = 2;
                    break;
                default:
                    this.queryParams.sortFeild = 0;
                    this.queryParams.sortType = 0;
                    break;
            }

            this.searchDecision.params.sortFeild = this.queryParams.sortFeild;
            this.searchDecision.params.sortType = this.queryParams.sortType;
        },
        searchByTechDesc(data) {
            console.log(data);
            // this.lg = 'zh';
            this.queryParams.pageNo = 1;
            this.queryParams.ptType = 0;
            this.queryParams.proposerType = 0;
            this.queryParams.lawStatus = 0;
            this.patentOrder = 0;
            this.currentSelectMenu = data;
            this.searchDecision.st = 1;
            // this.searchDecision.lang = 'zh';
            this.searchDecision.params = this.queryParams;
            this.searchDecision.type = data.index;
            this.loadPatantTechDescDatas();
        },
        async loadPatantTechDescDatas() {
            this.findOrder();
            const { data: res } = await this.$http.post("search/zj/tech/desc", this.searchDecision.params);
            if (res.code == 0) {
                if (res.data == null) {
                    this.$message.error('没有数据');
                    this.patentDataList = [];
                    this.patentDataTotal = 0;
                    return;
                }

                this.patentDataList = res.data.list;
                this.patentDataTotal = res.data.total;

                // 保存检索条件
                localStorage.setItem("searchInfo", JSON.stringify(this.searchDecision));
            } else {
                this.$message.error(res.msg);
            }
        },
        searchInType(data) {
            // this.lg = 'zh';
            this.queryParams.pageNo = 1;
            this.queryParams.ptType = 0;
            this.queryParams.proposerType = 0;
            this.queryParams.lawStatus = 0;
            this.patentOrder = 0;
            this.currentSelectMenu = data;
            this.searchDecision.st = 1;
            // this.searchDecision.lang = 'zh';
            this.searchDecision.params = this.queryParams;
            this.searchDecision.type = data.index;
            this.loadPatantDatas();
        },
        async loadPatantDatas() {
            var url = "";
            if (this.searchDecision.type === '00' || this.searchDecision.type === '11' || this.searchDecision.type === '22') {
                var level = 0;
                if (this.searchDecision.type === '00') {
                    level = 0;
                } else if (this.searchDecision.type === '11') {
                    level = 1;
                } else {
                    level = 2;
                }

                if (this.searchDecision.st === 1) {
                    // 类型检索
                    if (this.currentSelectMenu === null) {
                        this.$message.error('请先选择一个分类');
                        return;
                    }

                    if (this.searchDecision.lang === 'zh') {
                        // 中文的检索路径
                        url = "search/levelSearch/10/" + level;
                    } else {
                        // 英文的检索路径
                        url = "search/en/typeSearch/" + this.currentSelectMenu.index;
                    }
                } else if (this.searchDecision.st === 2) {
                    // 中文自定义检索
                    // this.searchDecision.params.type = this.searchDecision.type;
                    url = "search/custom/search";
                } else if (this.searchDecision.st === 3) {
                    // 英文自定义检索
                    url = "search/custom/en/search/10";
                }
            } else {
                if (this.searchDecision.st === 1) {
                    // 类型检索
                    if (this.currentSelectMenu === null) {
                        this.$message.error('请先选择一个分类');
                        return;
                    }

                    if (this.searchDecision.lang === 'zh') {
                        // 中文的检索路径
                        url = "search/menuSearch/10/" + this.currentSelectMenu.index;
                    } else {
                        // 英文的检索路径
                        url = "search/en/typeSearch/" + this.currentSelectMenu.index;
                    }
                } else if (this.searchDecision.st === 2) {
                    // 中文自定义检索
                    // this.searchDecision.params.type = this.searchDecision.type;
                    url = "search/custom/search";
                } else if (this.searchDecision.st === 3) {
                    // 英文自定义检索
                    url = "search/custom/en/search/10";
                }
            }

            this.findOrder();
            const { data: res } = await this.$http.post(url, this.searchDecision.params);
            if (res.code == 0) {
                if (res.data == null) {
                    this.$message.error('没有数据');
                    this.patentDataList = [];
                    this.patentDataTotal = 0;
                    return;
                }

                this.patentDataList = res.data.list;
                this.patentDataTotal = res.data.total;

                // 保存检索条件
                localStorage.setItem("searchInfo", JSON.stringify(this.searchDecision));
            } else {
                this.$message.error(res.msg);
            }
        },
        showCustomSearchDialog() {
            this.showDetailSearchDialog = true;
        },
        sendCustomSearchEvent() {
            this.$refs.customSearchDialogRef.doSearch();
        },
        doRealCustomSearch(data) {
            this.lg = data.searchType;
            if (data.searchType === 'zh') {
                // 中文检索
                this.doZhCustomSearch(data.params);
            } else {
                // 英文检索
                this.doEnCustomSearch(data.params);
            }
        },
        doZhCustomSearch(params) {
            // 反写参数
            this.patentOrder = 0;
            this.queryParams.pageNo = 1;
            this.queryParams.ptType = params.ptType;
            this.queryParams.proposerType = params.proposerType;
            this.queryParams.lawStatus = params.lawStatus;

            params.pageNo = this.queryParams.pageNo;
            params.pageSize = this.queryParams.pageSize;

            this.searchDecision.st = 2;
            this.searchDecision.lang = 'zh';
            // if (this.searchDecision.type !== '' && parseInt(this.searchDecision.type) >= 160 && parseInt(this.searchDecision.type) <= 180) {
            //     // 不处理类别选择
            // } else {
                this.searchDecision.type = '';
            // }
            
            this.searchDecision.params = params;

            this.showDetailSearchDialog = false;
            this.loadPatantDatas();
        },
        doEnCustomSearch(params) {
            // 反写参数
            this.patentOrder = 0;
            this.queryParams.pageNo = 1;
            this.queryParams.ptType = params.ptType;
            this.queryParams.proposerType = params.proposerType;
            this.queryParams.lawStatus = params.lawStatus;

            params.pageNo = this.queryParams.pageNo;
            params.pageSize = this.queryParams.pageSize;

            this.searchDecision.st = 3;
            this.searchDecision.lang = 'en';
            this.searchDecision.type = '';
            this.searchDecision.params = params;

            this.showDetailSearchDialog = false;
            this.loadPatantDatas();
        },
        zhSearch() {
            // if (this.searchDecision.st !== 1) {
            //     // 只有类型检索才需要切换
            //     return;
            // }
            this.lg = 'zh';
            this.searchDecision.lang = 'zh';
            this.queryParams.appCoun = '';
            this.searchDecision.params.appCoun = '';
            // this.loadPatantDatas();
        },
        enSearch() {
            // if (this.searchDecision.st !== 1) {
            //     // 只有类型检索才需要切换
            //     return;
            // }
            this.lg = 'en';
            this.searchDecision.lang = 'en';
            this.queryParams.proposerType = 0;
            this.searchDecision.params.proposerType = 0;
            this.queryParams.lawStatus = 0;
            this.searchDecision.params.lawStatus = 0;
            // this.loadPatantDatas();
        },
        async loadPatentDetail(row) {
            var url = "search/ptdetail";
            var param = {
                openNo: row.openNo
            };
            if (this.lg === 'en') {
                url = "search/en/ptdetail";
                param = {
                    mtype: 10,
                    appno: row.ptNo
                };
            }
            const { data: res } = await this.$http.get(url, {
                params: param
            });
            if (res.code == 0) {
                this.currentDetailPatent = {
                    lg: this.lg === 'en' ? 1 : 0,
                    baseInfo: row,
                    detail: res.data
                };
                this.showPatentDetailDialog = true;
            } else {
                this.$message.error(res.msg);
            }
        },
        selectRow(row, column, event) {
            this.currentDetailPatent = {};
            this.showDetailTitle = row.ptName;
            this.loadPatentDetail(row);
        },
        showReport() {
            // if (this.searchDecision.st === 0) {
            //     this.$message.error('请先检索专利数据');
            //     return;
            // }
            if (!this.checkLogin()) {
                return;
            }
            this.showReportDialog = true;
        },
    }
}
</script>

<style scoped>
.nav-title {
    width: 100%; 
    height: 40px; 
    background-color: rgb(7, 54, 125); 
    line-height: 40px; 
    font-size: 20px; 
    color: white; 
    text-indent: 1em;
}
.login-title {
    width: 100%;
    height: 30px;
    background-color: white;
    border-bottom: 1px solid rgb(194, 194, 194);
}
.pt-container {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    background-color: #f5f6f7;
}

.pt-header {
    width: 100%;
    height: 80px;
    background-color: rgb(7, 54, 125);
    border-bottom: 1px solid #ebeef5;
}

.pt-logo {
    width: 120px;
    height: 40px;
    margin-top: 20px;
    margin-left: 20px;
    float: left;
}

.pt-websitename {
    width: 800px;
    height: 80px;
    float: left;
    font-size: 24px;
}

.pt-web-total {
    width: 200px;
    height: 60px;
    line-height: 100px;
    float: right;
    font-size: 10px;
    color: rgb(255, 255, 255);
}

.pt-websitename-top {
    margin-top: 15px;
    font-size: 32px;
    color: rgb(255, 255, 255);
}
.pt-websitename-bom {
    font-size: 12px;
}

.pt-footer {
    width: 100%;
    height: 120px;
    background-color: #222;
}

.pt-footer-1 {
    width: 50%;
    height: 40px;
    float: left;
    font-size: 12px;
    line-height: 30px;
    margin-top: 30px;
    margin-left: 40px;
    color: white;
}

.pt-footer-2 {
    width: 45%;
    height: 40px;
    float: left;
    font-size: 12px;
    line-height: 30px;
    margin-top: 30px;
    margin-left: 40px;
    color: white;
}

.main-content {
    width: 1160px;
    min-width: 1160px;
    height: 100%;
    margin: auto;
    background-color: white;
}

.el-menu-vertical-demo {
    height: calc(100vh - 700px);
    overflow-y: auto;
}
.pt-class {
    width: 99.6%;
    height: 60px;
    line-height: 60px;
    text-indent: 1em;
    font-size: 18px;
    color: rgb(7, 54, 125);
    border-bottom: 1px solid #ebeef5;
    /* border-right: 1px solid #ebeef5; */
}
.pt-menus-list {
    width: 99.6%;
    height: calc(100vh + 100px);
    overflow-y: auto;
    background-color: white;
}
.pt-menus {
    width: 100%;
    height: 60px;
    line-height: 60px;
    /* text-indent: 1em; */
    font-size: 18px;
    color: rgb(7, 54, 125);
    border-bottom: 1px solid #ebeef5;
}
.pt-menus-left {
    width: 50%;
    height: 60px;
    float: left;
}
.pt-menus-right {
    width: 260px;
    height: 60px;
    float: right;
    text-align: right;
}
.pt-search-btn {
    margin-right: 32px;
}
.pt-select {
    margin-top: 10px;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ebeef5;
}
.pt-info-list {
    width: 100%;
    height: calc(100vh - 0px);
    overflow-y: auto;
    background-color: white;
}
.pt-info-page {
    width: 100%;
    height: 55px;
    text-align: center;
    background-color: white;
}
.pt-lg-zh {
    background-color: #fef0f0;
    color: #F56C6C;
    border: 1px solid #fbc4c4;
    font-size: 12px;
    padding: 8px 10px 8px 10px;
    border-radius: 32px;
    cursor: pointer;
    margin-right: 10px;
}
.pt-lg-zh-focus {
    background-color: #F56C6C;
    color: #FFF;
    border: 1px solid #F56C6C;
    font-size: 12px;
    padding: 8px 10px 8px 10px;
    border-radius: 32px;
    cursor: pointer;
    margin-right: 10px;
}
.pt-lg-en {
    background-color: rgb(189, 204, 255);
    color: rgb(83, 120, 255);
    border: 1px solid rgb(142, 166, 255);
    font-size: 12px;
    padding: 8px 10px 8px 10px;
    border-radius: 32px;
    cursor: pointer;
    margin-right: 10px;
}
.pt-lg-en-focus {
    background-color: rgb(108, 127, 196);
    color: white;
    border: 1px solid rgb(108, 127, 196);
    font-size: 12px;
    padding: 8px 10px 8px 10px;
    border-radius: 32px;
    cursor: pointer;
    margin-right: 10px;
}
</style>